export function getPropertyValue<T extends Record<string, unknown>>(
  obj: T | undefined,
  key: keyof NonNullable<T>
): string {
  return (obj?.[key] as string) ?? '';
}

export function getFutureEndDate(daysAhead = 328): Date {
  const today = new Date();
  const futureDate = new Date(today);
  futureDate.setDate(today.getDate() + daysAhead);
  return futureDate;
}

export function generateTimeSlots(
  intervalMinutes = 15
): Array<{ label: string; value: string }> {
  const totalSlots = (24 * 60) / intervalMinutes;

  return Array.from({ length: totalSlots }, (_, i) => {
    const totalMinutes = i * intervalMinutes;
    const hour = Math.floor(totalMinutes / 60);
    const minute = totalMinutes % 60;

    const value = `${hour.toString().padStart(2, '0')}:${minute
      .toString()
      .padStart(2, '0')}`;
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
    const period = hour < 12 ? 'am' : 'pm';
    const label = `${displayHour}:${minute
      .toString()
      .padStart(2, '0')}${period}`;

    return { label, value };
  });
}
